var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient-change",style:(("height: " + (this.$props.height) + "px; background-image: linear-gradient(" + (this.$props.from) + ", " + (this.$props.to) + ");"))})}
var staticRenderFns = []

export { render, staticRenderFns }